import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, InputGroup, FormControl, Button, Spinner, Alert } from 'react-bootstrap';
import { getFaces } from '../api';
import { useAccessToken } from '../hooks/useAccessToken';
import FaceCard from './FaceCard';

function Gallery() {
  const [faces, setFaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const getToken = useAccessToken();

  useEffect(() => {
    const fetchFaces = async () => {
      try {
        setLoading(true);
        const token = await getToken();
        const data = await getFaces(token);
        setFaces(data);
      } catch (err) {
        setError(err.message || 'Failed to fetch faces.');
      } finally {
        setLoading(false);
      }
    };
    fetchFaces();
  }, [getToken]);

  const filteredFaces = faces.filter((face) =>
    face.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <Container className="text-center my-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading faces...</span>
        </Spinner>
        <p>Loading faces...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="my-5">
        <Alert variant="danger">Error: {error}</Alert>
      </Container>
    );
  }

  return (
    <Container className="my-4">
      <h2 className="mb-4">Bad Memory</h2>

      <InputGroup className="mb-4">
        <FormControl
          placeholder="Search by name..."
          aria-label="Search by name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Button variant="outline-secondary">Search</Button>
      </InputGroup>

      {filteredFaces.length === 0 ? (
        <Alert variant="info">No faces found. Add a new person to get started!</Alert>
      ) : (
        <Row xs={2} sm={2} md={3} lg={4} className="g-4">
          {filteredFaces.map((face) => (
            <Col key={face.id}>
              <FaceCard face={face} />
            </Col>
          ))}
        </Row>
      )}

      {/* Floating Action Button for Adding New Person */}
      <Link
        to="/add"
        className="btn btn-primary rounded-circle shadow-lg d-flex align-items-center justify-content-center"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          width: '60px',
          height: '60px',
          fontSize: '2rem',
          textDecoration: 'none',
        }}
      >
        +
      </Link>
    </Container>
  );
}

export default Gallery;